import Tooltip, { Overlay } from '@components/Tooltip';
import cn from 'classnames';
import React, { MouseEventHandler } from 'react';
import styles from './Colors.module.scss';
import { groupColors, GroupColorHex, GroupColorLabel } from '@models/Group';

export function Color({
  hex,
  label,
  active,
  onMouseDown,
  placement = 'left',
}: {
  hex?: GroupColorHex;
  label: GroupColorLabel;
  active: boolean;
  onMouseDown: MouseEventHandler;
  placement?: 'left' | 'right';
}) {
  return (
    <Tooltip
      placement={placement}
      overlay={<Overlay className={cn(styles[`tooltip${placement}`])}>{label}</Overlay>}
      delay
    >
      <div
        className={cn(styles.color, !hex && styles.autoColor, active && styles.active)}
        onMouseDown={onMouseDown}
        style={{ '--bgColor': hex ? hex : 'var(--textPrimary)' } as React.CSSProperties}
      />
    </Tooltip>
  );
}

export default function Colors({
  active = null,
  onSelect,
}: {
  active: GroupColorHex;
  onSelect: (hex: string) => void;
}) {
  return (
    <div className={styles.colorList}>
      {groupColors.map(([hex, label], i) => (
        <Color
          active={active === hex}
          onMouseDown={() => onSelect(hex)}
          hex={hex}
          label={label}
          key={i}
        />
      ))}
    </div>
  );
}
